'use strict';

import execute_on from "../../../libs/execute-on";
import pointsPackageScript from "./pointsPackageScript";

execute_on('admin.points-package.edit', pointsPackageScript);
